import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-permissions-section',
  templateUrl: './permissions-section.component.html',
  styleUrls: ['./permissions-section.component.css'],
})
export class PermissionsSectionComponent implements OnInit {
  title = '';

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.title = this.route.snapshot.data.title;
  }
}
